module.exports = __webpack_public_path__ + "static/media/stillLifePencil.971e8620.jpg";